var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.756,
    height: 19.837,
    viewBox: "0 0 29.756 19.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye",
    "data-name": "Icon awesome-eye",
    d: "M29.576,13.664A16.569,16.569,0,0,0,14.878,4.5,16.572,16.572,0,0,0,.18,13.665a1.671,1.671,0,0,0,0,1.508,16.569,16.569,0,0,0,14.7,9.164,16.572,16.572,0,0,0,14.7-9.165A1.671,1.671,0,0,0,29.576,13.664Zm-14.7,8.193a7.439,7.439,0,1,1,7.439-7.439A7.439,7.439,0,0,1,14.878,21.858Zm0-12.4a4.924,4.924,0,0,0-1.308.2,2.472,2.472,0,0,1-3.456,3.456,4.948,4.948,0,1,0,4.764-3.652Z",
    transform: "translate(0 -4.5)",
    fill: "#21b6c5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEye);
export default __webpack_public_path__ + "static/media/blueEye.982c345527c0628f023b972c7690980b.svg";
export { ForwardRef as ReactComponent };